import {browserTracingIntegration, init, replayIntegration} from '@sentry/react';
import type {ErrorEvent, TransactionEvent} from '@sentry/types';

import {getConfig} from '@/config';
import {sentryBreadcrumbSanitizer, sentryEventSanitizer} from './sanitizers';

const config = getConfig();

if (!config.SENTRY.ACTIVE) {
    console.log('Sentry disabled in: ' + config.ENVIRONMENT);
} else {
    // biome-ignore lint/style/useCollapsedElseIf: collapsing doesn't mean the same thing here
    if (!window.TestingMode) {
        init({
            dsn: config.SENTRY.DSN,
            integrations: [browserTracingIntegration(), replayIntegration()],
            tracesSampleRate: 1.0,
            tracePropagationTargets: ['localhost', /^https:\/\/alvalabs\.io/],
            replaysSessionSampleRate: config.SENTRY.REPLAYS_RATE,
            replaysOnErrorSampleRate: config.SENTRY.REPLAYS_RATE_ERROR,
            beforeSend: sentryEventSanitizer<ErrorEvent>,
            beforeSendTransaction: sentryEventSanitizer<TransactionEvent>,
            beforeBreadcrumb: sentryBreadcrumbSanitizer
        });
        console.log('Sentry initialized');
    } else {
        console.log('Playwright detected, skipping Sentry');
    }
}
